import { SeasonCatalog } from 'types';

import { mapStringIntoOptions } from 'helpers/mapIntoOptions';

import { FormItem } from 'sections/EditForm';

const useDataForm = (seasonsCatalogs: SeasonCatalog[], catalog?: string[]): FormItem[] => {
  const seasons = seasonsCatalogs.map((item) => item.season);

  return [
    {
      name: 'season',
      label: 'season',
      type: 'select',
      options: mapStringIntoOptions(seasons),
    },
    {
      name: 'catalog',
      label: 'catalog',
      type: 'select',
      options: catalog && mapStringIntoOptions(catalog),
      isMulti: true,
    },
  ];
};

export { useDataForm };
